import { FC } from 'react';

import { useTranslation } from 'next-i18next/pages';

import { PlatformStatisticResult } from '@/api/statistic/types';
import { TranslationNamespace } from '@/i18n';

import { AnswerQuestionSection } from './AnswerQuestionSection/AnswerQuestionSection';
import { getAnswerAndQuestions } from './AnswerQuestionSection/AnswerQuestionSection.utils';
import { ContactInfoSection } from './ContactInfoSection/ContactInfoSection';
import { FishplaceNumbers } from './FishplaceNumbers/FishplaceNumbers';
import { MainInfoSection } from './MainInfoSection/MainInfoSection';
import { NewsSection } from './NewsSection/NewsSection';
import { WhoAreWeSection } from './WhoAreWeSection/WhoAreWeSection';
import { WithUsSection } from './WithUsSection/WithUsSection';

import styles from './AboutUsContainer.module.scss';

type Props = {
	initialStatistic: PlatformStatisticResult;
};

export const AboutUsContainer: FC<Props> = ({ initialStatistic }) => {
	const { t } = useTranslation(TranslationNamespace.Marketing);
	const aboutUsDescriptions = [
		t(
			'about-us-container.fishplace-is-an-innovative-solution-developed-by-fish-business-owners-fo',
		),
		t(
			'about-us-container.fishplace-is-a-dynamically-developing-community-that-brings-together-ent',
		),
		t(
			'about-us-container.join-fishplace-and-become-part-of-a-modern-community-of-fish-entrepreneu',
		),
	];
	const fishplaceInNumbersDescriptions = [
		t(
			'about-us-container.the-platform-audience-the-number-of-users-who-have-chosen-the-path-of-di',
		),
		t(
			'about-us-container.we-invite-you-to-join-us-on-the-path-to-the-new-comfortable-efficient-an',
		),
	];
	const answerAndQuestions = getAnswerAndQuestions(t);
	return (
		<div className={styles.container}>
			<MainInfoSection descriptions={aboutUsDescriptions} />
			<WhoAreWeSection />
			<FishplaceNumbers
				descriptions={fishplaceInNumbersDescriptions}
				statistic={initialStatistic}
			/>
			<NewsSection />
			<AnswerQuestionSection answerAndQuestions={answerAndQuestions} />
			<ContactInfoSection />
			<WithUsSection />
		</div>
	);
};
